// Copyright (c) 2018 Comsearch, Inc., All rights reserved
import React from 'react'
import { array, bool, object, string } from 'prop-types'
import Select, { createFilter } from 'react-select'

class MultiSelect extends React.Component {
  static propTypes = {
    disabled: bool,
    id: string.isRequired,
    input: object.isRequired,
    isClearable: bool,
    isMulti: bool,
    label: string,
    labelKey: string.isRequired,
    options: array.isRequired,
    valueKey: string.isRequired,
  }

  static defaultProps = {
    isMulti: true,
  }

  // react-select will include an option's value when filtering
  // so it the input is searching for '1', and there's an option with
  // '1' in its value property, it will include that in the options
  // even though the option's label doesn't necessarily have a '1' in it.
  // this can cause some unexpected behavior for the user:
  // they're searching for '11' (11 GHz band)
  // but it 14 GHz will show because its id is 11.
  filterOption = createFilter({
    matchFrom: 'start',
    stringify: option => option.label,
  })

  // dynamically maps the option label to display
  getOptionLabel = option => option[this.props.labelKey]

  // dynamically maps the option value for component internals and for redux-form
  getOptionValue = option => option[this.props.valueKey]

  // passes the onChange to redux-form
  // v is the entire new value. react-select handles the details of what changed.
  onChangeCustom = v => {
    const {
      input,
      isMulti,
    } = this.props

    // When using react-select (since v3) and isMulti is true, there is inconsistent behavior
    // when clearing a field (returns an empty array) vs removing all items one at a time. (returns null)
    // https://github.com/JedWatson/react-select/issues/3585
    const value = (
      v === null && isMulti
        ? []
        : v
    )

    input.onChange(value)
  }

  render () {
    const {
      disabled,
      input,
      id,
      isClearable,
      isMulti,
      label,
      options,
      valueKey,
    } = this.props

    return (
      <div className={'labeled-input multi-select'}>
        { label && <label id={`${id}-label`}>{label}</label> }
        <Select
          classNamePrefix={'react-select'}
          isClearable={isClearable}
          isDisabled={disabled}
          filterOption={this.filterOption}
          getOptionLabel={this.getOptionLabel}
          getOptionValue={this.getOptionValue}
          hideSelectedOptions={true}
          id={id}
          instanceId={id}
          isMulti={isMulti}
          onChange={this.onChangeCustom}
          options={options}
          value={input.value}
          valueKey={valueKey} />
      </div>
    )
  }
}

export default MultiSelect
